import { Component, OnInit, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { ClozeTestStyleModel } from "../model/cloze-test-style-model";

@Component({
  selector: "cloze-test-exercise-indicator",
  templateUrl: "./exercise-indicator.component.html",
  standalone: true,
  styleUrls: ["./exercise-indicator.component.scss"],
  imports: [],
})
export class ExerciseIndicatorComponent implements OnInit {
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);
  readonly testDone = input(false);
  readonly clozeTestStyleModel = input<ClozeTestStyleModel>({} as ClozeTestStyleModel);

  indicators: number[] = [];

  ngOnInit() {
    if (this.totalExercise()) {
      for (let i = 1; i <= this.totalExercise(); i++) {
        this.indicators.push(i);
      }
    }
  }
}
